import { MessageCircle, Phone, Mail, Instagram, Inbox, Sparkles } from "lucide-react";

const CARDS = [
    { key: "leads.recent", label: "Enquiries", icon: Inbox, testid: "stat-leads-recent" },
    { key: "leads.new", label: "Awaiting Call", icon: Sparkles, testid: "stat-leads-new", accent: true },
    { key: "clicks.whatsapp", label: "WhatsApp Taps", icon: MessageCircle, testid: "stat-clicks-whatsapp" },
    { key: "clicks.call", label: "Call Taps", icon: Phone, testid: "stat-clicks-call" },
    { key: "clicks.email", label: "Email Taps", icon: Mail, testid: "stat-clicks-email" },
    { key: "clicks.instagram", label: "Instagram Taps", icon: Instagram, testid: "stat-clicks-instagram" },
];

const pick = (obj, path) => path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj) ?? 0;

export const StatsGrid = ({ summary, days }) => (
    <div data-testid="admin-stats" className="grid grid-cols-2 gap-px border border-ivory/10 bg-ivory/10 md:grid-cols-3 lg:grid-cols-6">
        {CARDS.map((c) => (
            <div key={c.key} data-testid={c.testid} className="flex flex-col bg-night p-6">
                <c.icon size={16} strokeWidth={1.5} className={c.accent ? "text-gold" : "text-ivory/40"} />
                <span className={`mt-6 font-serif text-4xl font-light [font-feature-settings:'lnum'] ${c.accent ? "text-gold" : "text-ivory"}`}>
                    {summary ? pick(summary, c.key) : "—"}
                </span>
                <span className="mt-2 text-[10px] uppercase tracking-[0.2em] text-ivory/40">{c.label}</span>
                <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.2em] text-ivory/25">
                    {c.key === "leads.new" ? "all time" : `last ${days} days`}
                </span>
            </div>
        ))}
    </div>
);
